<template>
    <div class="logout-page">
        <div class="main-section">
            <h1>用户注销说明</h1>

            <p>亲爱的用户，您好</p>

            <p>为防止误操作，请确认是否注销账号并确认注销后的影响。该账号一旦注销，将无法恢复。即使您在注销
                后以相同的或其他的登录方式再次登录，此时该账号将视为新的用户账号。因此，我们善意地提醒您在
                申请注销前对需要备份的内容提前做好备份，并请 再次确认与账号相关的所有服务均已妥善处理，包括
                但不限于</p>

            <p>1、注销数据恢复卫士复账号是无法恢复的操作，您应自行备份该账号相关的信息和数据。注销后你将无
                法再使用本数据恢复卫士复账号中的任何信息和内容。</p>

            <p>2、账号将全部注销</p>

            <p>3、您的账号中的包括且不仅限于您的订单信息、反馈意见、检测报告、优惠券等内容将被彻底删除且无法找回。</p>

            <p>4、如果您的数据恢复卫士复账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，苏州念念不忘软件有限公司有权终止本账号的注销流程，且无需 另行得到您本人的同意。</p>

            <p>您的账号将在60天后被注销，当前所有登录将被退出。如果您在接下来的60天内重新登录此账号，则视为取消注销申请</p>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '数据恢复卫士', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '数据恢复卫士'
        },{                 // set meta
          name: 'description',
          content: '数据恢复卫士'
        }]
    },
    data(){
        return{
            
        }
    },
    mounted(){

    },
    created(){
        
    },
    methods:{
        
    },
    components:{
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';
.logout-page {
    padding-bottom: 10px;
    .main-section{
        padding:20px 20px 0;
    }
    .main-section > h1 {
        color: #262626;
        font-size: 18px;
        font-weight: bold;
    }
    .main-section > p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
        margin-top: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/static/majia02/Logout.vue